
import { Row, Col, Container, ButtonGroup, Button, Card, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import { css } from 'emotion';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import React, { useState, useEffect } from 'react';

function EirPhoneCarousel(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    const [imagePath, setPhoneImagePath] = useState((props.tile != '') ? props.tile.variants[0].image.path : '');
    const [stockStatus, setStockStatus] = useState((props.tile != '') ? props.tile.variants[0].inStock : '');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [displayModel, setdisplayModel] = useState(false);
    const [phoneFeatures, setPhoneFeatures] = useState([]);


    const selectVariant = (index) => {
        setPhoneImagePath(props.tile.variants[index].image.path);
        setStockStatus(props.tile.variants[index].inStock)
        setSelectedIndex(index);
    }

    const onClick = () => {
        // console.log('Index', selectedIndex);
        // console.log('image', imagePath);

        var devices = JSON.parse(localStorage.getItem("eir_be_data")).allDevices;
        var phone = devices.filter(phone => phone.id === props.tile.id);

        setPhoneFeatures(phone[0].features);

        setdisplayModel(true);
    }

    const toggleModel = () => {
        setdisplayModel(false);
    }

    const selectPhone = (event) => {
        props.afterPhoneSelected(props.tile, selectedIndex);
        event.preventDefault();
    }

    const changePhone = (event) => {
        props.changePhone();
        event.preventDefault();
    }

    const deselectPhone = (event) => {
        props.deselectPhone();
        event.preventDefault();
    }


    return (

        <div className={("phone-listing-desktop mt-mb-30 ") + (!isMobileOnly ? 'col-12 ' : '') + ((props.selectedPhoneTile) ? 'w-25' : '') + ((props.tile != '') ? '' : 'd-none')}>
            <Card className={(props.selectedPhoneTile) ? "phone-listing-card selected-phone" : "phone-listing-card"}>
                {(props.tile != '') &&
                    <div className='phone-listing-tile mb-3'>
                        <div className="phone-listing-tile-body">
                            {
                                !stockStatus &&
                                <div className={css`background-color: #d111c9; ` + ' roundel pl-roundel d-flex flex-column align-items-center justify-content-center position-absolute'} >OUT OF STOCK!</div>
                            }

                            {
                                props.tile.flash !== null && stockStatus &&
                                <div className={css`background-color: #d111c9; ` + ' roundel pl-roundel d-flex flex-column align-items-center justify-content-center position-absolute'} >{props.tile.flash.title}</div>
                            }
                            <div>
                                {imagePath &&
                                    <div className="p-0">
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <img className="w-100 mb-2 top-borders card-img-top" src={imagePath} />
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={(isMobileOnly) ? 'p-2 pb-3' : 'mb-2 mh-80'}>
                                <div className="phonebrand text-upper" dangerouslySetInnerHTML={renderContent(props.tile.manufacturer)}></div>
                                <div className="phonemodel" dangerouslySetInnerHTML={renderContent(props.tile.model)}></div>
                            </div>
                            {/* {(!isMobileOnly && !isTablet) && */}
                            <Row className="mb-2">
                                <div className="col-12 text-center pb-2 l-10">
                                    <ButtonGroup className={'colour-selector ml-3'} >
                                        {props.tile.variants.map((phone, index) => (
                                            <div key={index + phone.colour} className="d-flex flex-column justify-content-center align-items-center pl-0 pr-0">
                                                <div className='d-inline-flex btn-selected ml-1' style={(index == selectedIndex) ? { borderColor: '#' + phone.colour } : null}>
                                                    <Button
                                                        onClick={() => selectVariant(index)}
                                                        style={{ backgroundColor: '#' + ((phone.colour == "F3F3F3") ? 'e4e4e2' : phone.colour) }}
                                                        color="primary"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </ButtonGroup>
                                </div>
                                <div className="col-12">
                                    {props.tile.fromPrice != 0 ?
                                        <div className="phonebrand selectedPhonePrice  p-2 priceFrom">&euro;{+props.tile.fromPrice}</div>
                                        : <div className="phonebrand selectedPhonePrice  p-2 priceFrom">FREE</div>}
                                </div>
                                <div className={'col-12 mb-2 d-flex justify-content-center align-items-center ' + ((isMobileOnly) ? 'mt-2' : 'mt-3')}>
                                    <EirButton databundlecode={props.tile.id} type="button" text={"Select"} outline={(props.selectedPhoneTile) ? false : true} className={'select-phone d-none'} onClick={selectPhone}></EirButton>
                                    <EirButton databundlecode={props.tile.id} type="button" text={(props.selectedPhoneTile) ? "Selected" : "Select"} outline={(props.selectedPhoneTile) ? false : true} disabled={!stockStatus} className={(props.selectedPhoneTile) ? 'selectedButton' : ''} onClick={(props.selectedPhoneTile) ? deselectPhone : selectPhone} ></EirButton>
                                    {(props.selectedPhoneTile) && <span className="tick-icon"></span>}
                                </div>
                                {(props.selectedPhoneTile) &&
                                    <div>
                                        <div className="col-12 mt-1 mb-2 d-flex justify-content-center align-items-center">
                                            <EirButton type="link" className="changePhoneLink" text='Change Phone' onClick={changePhone} ></EirButton>
                                        </div>
                                        <div className="PhoneModel-disclaimer"><strong>Please Note: &nbsp;</strong>You may be asked to pay a Deposit when purchasing a Handset</div>
                                    </div>
                                }
                            </Row>
                            {/* } */}
                            {/* {(isMobileOnly || isTablet) &&
                            <Row className="mb-3">
                                <div className="col-12">
                                    <div className="phonebrand p-2" dangerouslySetInnerHTML={renderContent(props.tile.PhonePrice)}></div>
                                </div>
                                <div className="col-12">
                                    <ButtonGroup className={'colour-selector d-flex justify-content-center align-items-center'} >
                                        {props.tile.Phones.map((phone, index) => (
                                            <div key={index + phone.PhoneImageColor} className="d-flex flex-column justify-content-start align-items-center">
                                                <div className='d-inline-flex btn-selected ml-1' style={(index == selectedIndex) ? { borderColor: phone.PhoneImageColor } : null}>
                                                    <Button
                                                        onClick={() => selectVariant(index)}
                                                        style={{ backgroundColor: phone.PhoneImageColor }}
                                                        color="primary"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </ButtonGroup>
                                </div>
                            </Row>
                        } */}

                        </div>
                    </div>
                }
                {/* {(props.ctaImage) && */}
                {(!props.selectedPhoneTile) &&
                    <div className="p-0">
                        <div className="d-flex flex-column justify-content-center align-items-center mt-2">
                            <div role="button" onClick={onClick} className={'plus_cta card-img-bottom ' + (css`background-image: url(/.galleries/eir/icons/plus-circle.png); &:hover, &:active {background-image: url(/.galleries/eir/icons/plus-circle-hover.png) !important;}`)} id={props.id}></div>
                        </div>
                    </div>
                }
                {/* } */}
            </Card>
            <Modal className="modalDialog" centered={true} isOpen={displayModel} toggle={toggleModel} >
                <ModalBody className={"modalContent " + ((isMobileOnly) ? 'p-4' : 'p-5')}>

                    <img onClick={toggleModel} src={'/.galleries/eir/icons/plus-circle-hover.png'} alt="Close" className="phonedetails-close-icon" />

                    <Row>
                        <Col sm="12" md="4" lg="4" className="d-flex justify-content-center align-items-center">
                            <img className={'mb-2 w-75'} src={imagePath} />
                        </Col>
                        <Col sm="12" md="8" lg="8" className="d-flex justify-content-center align-items-center">
                            <div>
                                <div className="phonebrand mb-2" >{props.tile.manufacturer}</div>
                                <div className="phonemodel mb-2" >{props.tile.model}</div>
                                <div className="phoneDetails phonebrand d-flex ">
                                    {phoneFeatures ? <ul>{phoneFeatures.map((li, i) => <li key={i}>{li}</li>)}</ul> : ""}
                                </div>
                                <div className="PhoneModel-disclaimer"><strong>Please Note: &nbsp;</strong>You may be asked to pay a Deposit when purchasing a Handset</div>
                                {/* {props.tile.fromPrice != 0 ?
                                    <div className="phoneprice phonemodel mb-2">&euro;{props.tile.fromPrice}</div>
                                    : <div className="phoneprice phonemodel mb-2">FREE</div>}
                                <div className="callus"> Call our team on &nbsp;
                            <a className="sticky-modal-href" href={"tel:1800 242 556"} className={'sticky-overlay'}>1800 242 556 </a>
                                </div> */}
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    )
}
export default EirPhoneCarousel;